import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, shallowRef, watch } from "vue";
import { useStore } from "@/stores";
import router from "@/router";
import DuduAjax from "@/utils/DuduAjax";
import { API_BIS_PROJECT } from "@/configs/Apis";

import DEmpty from "../components/DEmpty.vue";
import ProjectEditDialog from "./components/ProjectEditDialog.vue";
import ProjectCopyDialog from "./components/ProjectCopyDialog.vue";
import ProjectMergeDialog from "./components/ProjectMergeDialog.vue";
import ProjectImportDialog from "./components/ProjectImportDialog.vue";
import ProjectAboutDialog from "./components/ProjectAboutDialog.vue";

import { showConfirm, showSuccess } from "@/utils/UI";

import permissionChecker from "@/permission/PermissionChecker";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectIndex',
  setup(__props) {

const store = useStore();

const projectName = ref("");

const cachedAllProjects = ref<Array<any>>([]);
const projectList = ref<Array<any>>([]);
const currentProject = shallowRef();

const currentProjectId = computed(() => currentProject.value?.id ?? 0);

const loading = ref(false);

const selectedProjects = ref<Array<any>>([]);

const showLicenseWarning = ref(false);
const licenseWarningMessage = ref("");

const editDialog = shallowRef<any>(null);
const copyDialog = shallowRef<any>(null);
const mergeDialog = shallowRef<any>(null);
const importDialog = shallowRef<any>(null);
const aboutDialog = shallowRef<any>(null);

const logout = async () => {
  await store.dispatch("user/logout");
  router.push("login");
};

const loadProjectData = async () => {
  loading.value = true;
  try {
    const data = await DuduAjax.get(API_BIS_PROJECT);
    const newData = ((data as Array<any>) || []).map((item) => Object.assign(item, { _tid: Math.random().toString() }));
    projectList.value = cachedAllProjects.value = newData;
  } finally {
    loading.value = false;
  }
};

const openProjectEdit = () => {
  editDialog.value.open();
};

const navToBis = () => {
  window.open("http://bis.quan-ip.com/sso.html");
};

const openProjectMerge = () => {
  mergeDialog.value.open();
};

const editProject = (project: any) => {
  editDialog.value.open(project);
};

const copyProject = (item: any) => {
  copyDialog.value.open(item);
};

const deleteProject = async (project: any) => {
  const confirmed: any = await showConfirm("是否确认删除这个数据库？").catch(() => "");
  if (!confirmed) {
    return;
  }
  await DuduAjax.delete(API_BIS_PROJECT, project.id);
  showSuccess("删除成功");
  loadProjectData();
};

const onDialogSaved = () => {
  selectedProjects.value = [];
  loadProjectData();
};

const onProjectSelected = (project: any, checked: boolean) => {
  if (checked) {
    selectedProjects.value.push(project);
  } else {
    selectedProjects.value = selectedProjects.value.filter((p) => p.id !== project.id);
  }
};

const isCheckboxDisable = (project: any): boolean => {
  return selectedProjects.value.length >= 2 && !selectedProjects.value.some((p) => p.id === project.id);
};

const openDataImport = (item: any) => {
  currentProject.value = item;
  importDialog.value.open();
};

const navToPatentList = async (item: any) => {
  // 加载标引字段
  try {
    loading.value = true;
    await store.dispatch("project/setProjectInfo", JSON.parse(JSON.stringify(item)));
    await router.push({ name: "patent-list", params: { projectId: item.id } } as any);
  } finally {
    loading.value = false;
  }
};

const navToReport = async (item: any) => {
  // 加载标引字段
  try {
    loading.value = true;
    await store.dispatch("project/setProjectInfo", JSON.parse(JSON.stringify(item)));
    await router.push({ name: "report", params: { projectId: item.id } });
  } finally {
    loading.value = false;
  }
};

const searchProject = () => {
  const foundItems = cachedAllProjects.value.filter((item) => item.name.indexOf(projectName.value) > -1);
  projectList.value = JSON.parse(JSON.stringify(foundItems));
};

const checkLicense = async () => {
  const data: any = await aboutDialog.value.checkLicense();
  if (data.secretKey && data.licenseType !== "INVALID" && data.expiredDate) {
    const days: number = Math.floor(
      (new Date(data.expiredDate).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24)
    );
    if (days < 15) {
      showLicenseWarning.value = true;
      licenseWarningMessage.value = `产品授权还有 ${days} 天就要过期, 点击右上角查看详细授权信息`;
    }
  }
};

watch(projectName, () => searchProject());

onMounted(async () => {
  store.dispatch("project/clearProject");
  await loadProjectData();
  await checkLicense();
});

return { __sfc: true,store, projectName, cachedAllProjects, projectList, currentProject, currentProjectId, loading, selectedProjects, showLicenseWarning, licenseWarningMessage, editDialog, copyDialog, mergeDialog, importDialog, aboutDialog, logout, loadProjectData, openProjectEdit, navToBis, openProjectMerge, editProject, copyProject, deleteProject, onDialogSaved, onProjectSelected, isCheckboxDisable, openDataImport, navToPatentList, navToReport, searchProject, checkLicense, DEmpty, ProjectEditDialog, ProjectCopyDialog, ProjectMergeDialog, ProjectImportDialog, ProjectAboutDialog, permissionChecker }
}

})